import React from 'react';

import type { IconProps } from '@/core/components/Icons/Icons';

const ShieldIcon: React.FC<IconProps> = ({ className }) => (
  <svg className={className} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.0026 18.3346C10.0026 18.3346 16.6693 15.0013 16.6693 10.0013V4.16797L10.0026 1.66797L3.33594 4.16797V10.0013C3.33594 15.0013 10.0026 18.3346 10.0026 18.3346Z"
      strokeWidth="2.08"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ShieldIcon;
